import styled from "styled-components";
import React, { useState, useEffect, useContext } from "react";
import notificationsServices from "services/notificationsServices";
import jwtDecode from "jwt-decode";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
// import { updateNotification } from '../../store/actions/notificationData';
import { Notification } from "types/notificatonTypes";
import { toast } from "react-toastify";
import chatServices from "services/chatServices";
import { AllConversationsContext } from "contexts/allConversationsContext";
import { useLocation } from "react-router-dom";
import chatIcon from "../../assets/icons/chat-bubbles.svg";
import { useTranslation } from "react-i18next";

const Chats = () => {
  const { t } = useTranslation();
  const token = localStorage.getItem("token");
  const { push } = useHistory();
  const dispatch = useDispatch();
  const history = useHistory();
  const loc = useLocation();
  const isChatRouteActive = loc.pathname === "/chat";

  const [notificationCounter, setNotificationsCounter] = useState("0");
  const isNotificatonNumChange = useSelector((state: any) => state.notificationPageNumberReducer);
  const permission = useSelector((state: any) => state.permissions.permissions);

  const isAdmin = permission[0]?.Id === -1;

  const location = useLocation();
  const pathname = location.pathname;

  const isElemHasPermission =
    isAdmin ||
    (!!permission.find((permission: any) => permission.Id === 191) &&
      pathname.includes("/structure"));

  const isPlayerDetailActive = !!permission.find((permission: any) => permission.Id === 135);

  const playerDetailischatActive =
    isAdmin ||
    (!!permission.find((permission: any) => permission.Id === 285) && isPlayerDetailActive);

  const isRadarPlayerDetailActive = !!permission.find((permission: any) => permission.Id === 282);

  const playerRadarIsChatActive =
    isAdmin ||
    (!!permission.find((permission: any) => permission.Id === 286) && isRadarPlayerDetailActive);

  const isRadarPlayerInvitationActive = !!permission.find(
    (permission: any) => permission.Id === 262
  );

  const playerRadarInvitationIsChatActive =
    isAdmin ||
    (!!permission.find((permission: any) => permission.Id === 287) &&
      isRadarPlayerInvitationActive);

  const isPlayerSectionActive = !!permission.find((permission: any) => permission.Id === 134);

  const isPlayerChatActive =
    isAdmin ||
    (!!permission.find((permission: any) => permission.Id === 185) && isPlayerSectionActive);

  const isGlobalChatActive =
    isAdmin || !!permission.find((permission: any) => permission.Id === 318);

  // const isChatActive =
  //   isElemHasPermission ||
  //   playerDetailischatActive ||
  //   playerRadarIsChatActive ||
  //   playerRadarInvitationIsChatActive ||
  //   isPlayerChatActive || isGlobalChatActive;

  const isChatActive = isGlobalChatActive;

  // const isChatHasPermission =
  //   permission[0]?.Id === -1
  //     ? true
  //     : !!permission.find((permission: any) => permission.Id === 215);

  const [
    allConversations,
    setAllConversations,
    selectedChatAcademy,
    setSelectedChatAcademy,
    searchQuery,
    setSearchQuery,
    conversation,
    setConversation,
    conversationMembers,
    setConversationMembers,
    activeConversationImageUrl,
    setActiveConversationImageUrl,
    activeConversationName,
    setActiveConversationName,
    onlineProfiles,
    setOnlineProfiles,
    activeConversationId,
    setActiveConversationId,
    activeConversationType,
    setActiveConversationType,
    tempMemberId,
    setTempMemberId,
    unreadMessagesCounter,
    setUnreadMessagesCounter,
    allInterlocutors,
    setAllInterlocutors,
    auxFolderName,
    setAuxFolderName,
    activeMemberType,
    setActiveMemberType,
    tempConversationId,
    setTempConversationId,
    activeConversationCreatedBy,
    setActiveConversationCreatedBy,
    addNewConversation,
    toggleAddNewConversation,
    addNewGroupConversation,
    toggleAddNewGroupConversation,
    chatAcademies,
    setChatAcademies,
  ] = useContext(AllConversationsContext);

  const handleButtonClick = () => {
    if (isChatActive) {
      push("/chat");
    } else {
      toast.error(t("common.noPermission"));
    }
  };

  return (
    <>
      <Div
        notificationsNumber={unreadMessagesCounter}
        active={isChatRouteActive}
        onClick={handleButtonClick}
        style={{
          cursor: isChatActive ? "pointer" : "default",
        }}
      >
        <SvgBox active={isChatRouteActive}>
          <img
            src={chatIcon}
            alt="chat"
            style={{
              height: "17px",
              width: "17px",
            }}
          />
        </SvgBox>

        <p
          style={{
            opacity: isChatActive ? "" : "0.4",
            fontSize: "14px",
            color: isChatRouteActive ? "#FF9200" : "#9CB0C4",
          }}
        >
          {t("chat.title")}
        </p>
      </Div>
    </>
  );
};

export default Chats;

const SvgBox = styled.div<{ active?: boolean }>`
  width: 28px;
  height: 28px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  /* background: ${({ active }) => (active ? "#061c2e" : "#092a44")}; */
  transition: box-shadow 0.2s, transform 0.2s, background 0.2s;
  /* border: ${({ active }) => (active ? "1px solid #FF9200" : "")}; */
  /* transform: ${({ active }) => (active ? "translateY(2px) scale(0.97)" : "none")}; */

  ${({ active }) =>
    !active &&
    `
      &:hover {
        // box-shadow: 0 0 8px 2px orange;
        // border: 1px solid #9CB0C4;

      }
    `}
`;

export const Div = styled.div<{
  notificationsNumber?: string;
  active?: boolean;
}>`
  /* width: 100px !important; */
  position: relative;
  display: flex;
  align-items: center;
  cursor: ${({ active }) => (active ? "default" : "pointer")} !important;
  gap: 10px;
  width: 100%;
  padding: 0px 4px;
  border-radius: 10px;
  // padding-bottom: 12px;

  & > p {
    font-size: 10px;
    font-weight: 400;
    color: lightgray;
    /* text-transform: uppercase; */
  }
  background: ${({ active }) => (active ? "black" : "unset")};
  border: ${({ active }) => (active ? "1px solid rgba(156, 176, 196, 0.3)" : "unset")};
  ${({ active }) =>
    !active &&
    `
      &:hover {
        // box-shadow: 0 0 8px 2px orange;
        // border: 1px solid #9CB0C4;
        background:rgba(156, 176, 196, 0.3);
      }
    `}

  &:before {
    content: ${({ notificationsNumber }) =>
      `"${
        Number(notificationsNumber ?? 0) > 0
          ? "+" + (notificationsNumber ?? 0)
          : notificationsNumber ?? 0
      }"`};

    display: ${({ notificationsNumber }) => (notificationsNumber === "0" ? "none" : "flex")};
    justify-content: center;
    align-items: center;
    width: 15px;
    height: 15px;
    border-radius: 50%;
    background: #ff9200;
    padding: 1px 0;

    font-size: ${({ notificationsNumber }) =>
      notificationsNumber !== undefined ? (notificationsNumber >= "100" ? "7px" : "8px") : ""};
    font-weight: 700;
    z-index: 99;
    position: absolute;
    left: 7px;
    top: -1px;

    padding: ${({ notificationsNumber }) => {
      const number = Number(notificationsNumber);

      if (isNaN(number)) return;

      if (number <= 99) {
        return "0px";
      } else if (number >= 100 && number <= 999) {
        return "11px";
      } else if (number >= 1000) {
        return "13px";
      }

      return "4px";
    }};
  }
`;
